export const FIRST_SCRIPT_TEMPLATE =
  "SELECT DISTINCT name FROM tournaments;\n" +
  "SELECT\n" +
  "   (SELECT COUNT(*) FROM players) AS total_players,\n" +
  "   (SELECT COUNT(*) FROM tournaments) AS total_tournaments,\n" +
  "   (SELECT COUNT(*) FROM games) AS total_games;";
